import { UniqueEntityID } from "./unique_entity_Id";


export abstract class AggregateRoot<T> {
    protected readonly _id: UniqueEntityID;
    protected readonly props: T;

    protected constructor(props: T, id?: UniqueEntityID) {
        this._id = id ?? new UniqueEntityID();
        this.props = props;
    }
}
